import {
  useUserEmailNotificationPreferences,
  useUserEmailNotificationPreferenceUpdate
} from "@/api";
import { Settings } from "@/components/ui/SettingsSection";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { Switch } from "@/components/ui/switch";
import { toast } from "@/components/ui/use-toast";
import { EmailNotificationCategory } from "@/gql/__generated__/graphql";
import { EmailNotificationItem } from "../../types/emailNotification.type";
import { generateEmailNotificationCategories } from "../../utils/generateEmailNotificationCategories";

export function EmailNotifications() {
  const { data, error, loading } = useUserEmailNotificationPreferences();
  const [updatePreference] = useUserEmailNotificationPreferenceUpdate();

  if (error) console.error(error);

  const categories = generateEmailNotificationCategories(data);

  function handleCheckedChange(changed: EmailNotificationItem) {
    updatePreference({
      variables: {
        emailCategory: EmailNotificationCategory[changed.category],
        value: !changed.value
      }
    }).catch((err) => {
      toast({
        title: "Unable to update preferences",
        description:
          "An error occurred while trying to update email notification preferences. Please try again later."
      });
      console.error(err);
    });
  }

  return (
    <Settings.Section title="Email notifications">
      {categories.map((category) => (
        <Settings.Item
          key={category.title}
          title={category.title}
          description={category.description}
        >
          {loading ? (
            <div className="my-[3px]">
              <LoadingCircle />
            </div>
          ) : (
            <Switch
              checked={!category.value}
              onCheckedChange={() => handleCheckedChange(category)}
            />
          )}
        </Settings.Item>
      ))}
    </Settings.Section>
  );
}
